import React from "react";

export const CaseCompareTable = ({ comparison, only }) => {
  if (!comparison?.columns?.length) return null;
  const keep = comparison.columns.map((c, i) => (only?.length && comparison.columns.some((x) => only.includes(x.display_id)) ? (only.includes(c.display_id) ? i : -1) : i)).filter((i) => i >= 0);
  const cols = keep.map((i) => comparison.columns[i]);
  const filtered = keep.length < comparison.columns.length;
  return (
    <div id="case-comparison" className="scroll-mt-4">
    <p className="mb-2 text-sm font-semibold text-[#0B192C]" data-testid="case-compare-title">{filtered ? `Your comparison (${cols.length} plan${cols.length === 1 ? "" : "s"})` : "Top choices side by side"}</p>
    <div className="overflow-x-auto rounded-xl border border-[#D9D6CC] bg-white" data-testid="case-compare-table">
      <table className="w-full min-w-[640px] text-sm">
        <thead>
          <tr className="bg-[#0B192C] text-left text-white">
            <th className="w-40 p-3 font-semibold">Side by side</th>
            {cols.map((c) => <th key={c.display_id} className="p-3 font-semibold">{c.plan_name}<div className="text-xs font-normal text-white/70">{c.carrier}</div></th>)}
          </tr>
        </thead>
        <tbody>
          {comparison.rows.map((r, ri) => (
            <tr key={ri} className="border-t border-[#EEEBE3] align-top" data-testid={`case-compare-row-${ri}`}>
              <th scope="row" className="sticky left-0 z-10 bg-white p-3 text-left font-medium text-[#0B192C]">{r.label}</th>
              {keep.map((k) => r.values[k]).map((v, i) => (
                <td key={i} className={`p-3 ${v.known ? "text-[#0B192C]" : "text-[#7A5A12]"}`}>
                  {v.url && v.text.length > 40 ? <>{v.text} <a href={v.url} target="_blank" rel="noopener noreferrer" className="underline text-[#1E3E62]">Open document</a></>
                    : v.url ? <a href={v.url} target="_blank" rel="noopener noreferrer" className="underline text-[#1E3E62]">{v.text}</a> : v.text}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};
